import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Check if the app has been pre-rendered by react-snap
if (rootElement.hasChildNodes()) {
  // Hydrate the pre-rendered HTML.
  // onRecoverableError captures component stack details for any remaining
  // hydration mismatch (React error #418) in the production console.
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    {
      onRecoverableError(error, errorInfo) {
        const msg = error && (error.message || String(error));
        console.error('[hydrateRoot] Recoverable error:', msg);
        if (errorInfo && errorInfo.componentStack) {
          console.error('[hydrateRoot] Component stack:', errorInfo.componentStack);
        }
      }
    }
  );
} else {
  // First render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
